// A skip to content component that is located outside the main content and is used to skip to the main content.
import { useAppSelector } from 'hooks/hooks'
import { useEffect, useRef, useState } from 'react'
import { selectActivePage } from 'store/navigationslice'

const SkipToContent = () => {
  const [hasFocus, setHasFocus] = useState(false)
  const skipToContentRef = useRef<HTMLAnchorElement>(null)
  const activePage = useAppSelector(selectActivePage)

  useEffect(() => {
    if (activePage) {
      setFocusOnTitle()
    }
  }, [activePage])

  const setFocusOnTitle = () => {
    document.getElementById('main-content')?.focus()
  }

  return (
    <>
      <a
        className={`${'btn btn-sm btn-primary position-absolute skip-to-content'} ${
          hasFocus ? 'skip-to-content--focus' : ''
        }`}
        ref={skipToContentRef}
        tabIndex={0}
        href="#"
        onClick={(e) => {
          e.preventDefault()
          setFocusOnTitle()
        }}
        onFocus={() => setHasFocus(true)}
        onBlur={() => setHasFocus(false)}
      >
        Till innehållet
      </a>
    </>
  )
}
export default SkipToContent
